import Moment from 'moment';
import CONST from './const';

const Utils = {

    setDecimalFormat: function (value) {
        if (isNaN(value)) {
            return value;
        }

        return value.toLocaleString('it-IT', {
            style: 'decimal',
            maximumFractionDigits: 2,
        });
    },

    setDateFormatUSA: function (value) {
        let date = Moment(value, "DD/MM/YYYY");
        return date.isValid() ? date.format('YYYY-MM-DD') : value;
    },

    setDateFormatITA: function (value) {

        let date = Moment(value, "YYYY-MM-DD");
        return date.isValid() ? date.format('DD/MM/YYYY') : value;
    },

    setIntegerFormat: function (value) {
        if (isNaN(value) || !value) {
            value = 0
        }
        return value.toLocaleString('it-IT', {
            style: 'decimal',
            maximumFractionDigits: 0,
        });
    },

    setPercentFormat: function (value) {

        if (isNaN(value)) {
            return 'N.D.'
        }
        return value.toLocaleString('it-IT', {
            style: 'decimal',
            minimumFractionDigits: 2,
        }) + ' %';
    },

    setCurrencyFormat: function (value) {

        if (isNaN(value)) {
            return 'N.D.'
        }

        return value.toLocaleString('it-IT', {
            style: 'currency',
            currency: 'EUR',
        });

    },

    getRequestStatusSettings: function (status) {

        if (CONST.REQUEST_STATUSES.hasOwnProperty(status)) {
            return CONST.REQUEST_STATUSES[status];
        } else {
            return {variant: 'info', label: 'in attesa'};
        }

    },

    getRequestStatuses: function () {

        return CONST.REQUEST_STATUSES;

    },

    getNoticeLevelSettings: function (level) {

        if (CONST.NOTICE_LEVELS.hasOwnProperty(level)) {
            return CONST.NOTICE_LEVELS[level];
        } else {
            return {variant: 'info', name: 'info'};
        }

    },

    getNoticeLevels: function () {

        return CONST.NOTICE_LEVELS;

    },

    validateEmail(email) {
        return email.match(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/) !== null;
    },

    validatePhone(phone) {
        return phone.match(/^[0-9]+$/ ) !== null;
    }

};

export default Utils;
